<template>
  <div>
    <!-- PUBLIC NOTES MODAL -->
    <div class="text-center">
      <v-dialog 
        v-model="dialog_notes"
        max-width="950px"
        style='z-index: 2;'
      >
        <v-row justify="center">
          <v-card style="border-top: 5px solid rgb(86, 182, 229);" min-width="500px">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
            >
              <v-table
                fixed-header
                fixed-footer
                height="80vh"
              >
                <thead>
                  <tr>
                    <th>
                      <v-card-title style="width: 100%;">
                        <v-toolbar class="bg-white">
                          <v-icon
                            style="float: left; background-color: rgb(86, 182, 229); color: #fff;"
                            class="float-left mr-2"
                            @click="store.setDialogNotes(false)"
                            >mdi-chevron-left</v-icon
                          >
                          <v-toolbar-title 
                            class="ml-n1"
                            color="rgb(86, 182, 229)"
                          >
                            Public Notes
                          </v-toolbar-title>
                          <v-icon
                            color="rgb(86, 182, 229)"
                            class="float-right"
                            @click="$emit('add_note')"
                            >mdi-cached</v-icon
                          >
                        </v-toolbar>
                      </v-card-title>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td>
                      <v-card-text style="width: 100%;">
                        <v-row>
                          <v-col cols="12" md="12" sm="12">
                            <v-toolbar color="rgb(255, 255, 255)">
                              <span class="text-ellipsis font-weight-bolder" style="color: rgb(86, 182, 229);">
                                {{ current_pdf['itemName'] }}
                              </span>
                            </v-toolbar>
                            
                            <v-card
                              class="mx-auto elevation-0"
                              v-if="Object.keys(notes).length > 0"
                            >
                              <!-- Agenda Table -->
                              <v-table height="100vh">
                                <tbody
                                  v-for="(item, key, index) in notes" 
                                  :key="index"
                                  class="table-striped"
                                >
                                  <tr
                                    style="height: 100%;"
                                  >
                                    <td
                                      style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                                    >
                                      <v-list class="bg-transparent">
                                        <v-list-item
                                          active-color="rgb(86, 182, 229)"
                                        >
                                          <template v-slot:append v-if="item.userId == user.userInfo.userId">
                                            <v-icon
                                              style="float: right; background-color: rgba(0, 0, 0, .05); color: rgb(86, 182, 229);"
                                              size="x-large"
                                              >mdi-note-multiple-outline</v-icon
                                            >
                                          </template>
        
                                          <template v-slot:prepend v-if="item.userId != user.userInfo.userId">
                                            <v-icon
                                              style="float: left; background-color: rgba(0, 0, 0, .05); color: rgb(86, 182, 229);"
                                              size="x-large"
                                              >mdi-note-multiple</v-icon
                                            >
                                          </template>
        
                                          <v-list-item-title>
                                            <span :class="item.userId == user.userInfo.userId ? 'text-ellipsis font-weight-bold float-right' : 'text-ellipsis font-weight-bold float-left'">
                                              {{ item.note }}
                                            </span>
                                          </v-list-item-title>
        
                                          <v-list-item-subtitle>
                                            <span :class="item.userId == user.userInfo.userId ? 'text-ellipsis float-right' : 'text-ellipsis float-left'">
                                              {{ item.userName }} - {{ formatDateAndTime(item.noteDate) }}
                                            </span>
                                          </v-list-item-subtitle>
                                        </v-list-item>
                                      </v-list>
                                    </td>
                                  </tr>
                                </tbody>
                              </v-table>
                            </v-card>
        
                            <v-card
                              class="mx-auto elevation-0"
                              v-else
                            >
                              <v-table class="bg-grey-lighten-5" height="100vh">
                                <tbody>
                                  <tr>
                                    <td class="text-center">
                                      <span>
                                        No public notes found for this document
                                      </span>
                                    </td>
                                  </tr>
                                </tbody>
                              </v-table>
                            </v-card>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </td>
                  </tr>
                </tbody>
                <tfoot>
                  <tr>
                    <td class="bg-white">
                      <v-textarea
                        class="mt-4"
                        label="Type your notes here"
                        rows="1"
                        variant="outlined"
                        v-model="comment"
                        :rules="rules.textRules"
                      >
                        <template v-slot:append>
                          <v-btn 
                            block
                            color="rgb(86, 182, 229)"
                            class="text-white mt-n2"
                            @click="addDocumentNotes"
                            :loading="store.getLoading"
                          >
                            Add
                          </v-btn>
                        </template>
                      </v-textarea>
                    </td>
                  </tr>
                </tfoot>
              </v-table>
            </v-form>
          </v-card>
        </v-row>
      </v-dialog>
    </div>
  </div>
</template>

<script>
var moment = require("moment");
import axios from "axios";
import UserData from "../repository/UserData";
import { useAuthStore } from "../../stores/auth";
import { useIndexStore } from "../../stores/index";
import { useAlertStore } from "../../stores/alert";

export default {
  name: "PublicNotes",
  props: {
    notes: {
      type: Array,
      default: () => [],
    },
  },

  data: () => ({
    valid: false,
    comment: "",
    reply: "",
    show: false,
    current_comment: "",
    reply_comment: {},
    opened: [],
    rules: {
      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 3) || "Min 3 characters",
      ],
      selectRules: [(v) => !!v || "Select is required"],
      textRules: [
        v => !!v || 'Field is required',
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
      characterRules: [
        v => (v && v.length >= 3) || 'Min 3 characters',
      ],
    },
    token: localStorage.getItem("token") ? JSON.stringify(localStorage.getItem("token")).slice(1, -1) : "",
    auth: useAuthStore(),
    store: useIndexStore(),
    alert: useAlertStore(),
  }),

  computed: {
    user() {
      return this.auth.getLoggedInUser;
    },

    dialog_notes() {
      return this.store.getDialogNotes;
    },

    current_pdf() {
      return this.store.getCurrentPdf;
    },
  },
  
  methods: {
    formatDateAndTime(date) {
      return moment.unix(date).format("DD MMM YYYY, hh:mm A");
    },

    validate() {
      return this.$refs.form.validate();
    },

    resetForm() {
      return this.$refs.form.reset();
    },

    resetValidation() {
      return this.$refs.form.resetValidation();
    },

    reset() {
      this.reply = "";
      this.comment = "";
      this.resetValidation();
      document.querySelector('html').classList.remove('v-overlay-scroll-blocked');
    },

    noRepliesFound() {
      this.alert.showInfo('No replies found');
    },

    addDocumentNotes() {
      this.validate().then((validator_response) => {
        this.valid = validator_response.valid;
        if (this.valid) {
          const formData = new FormData();
          formData.append("userId", UserData.getUserId() ? UserData.getUserId() : this.user.userInfo.userId);
          formData.append("companyCode", UserData.getCompanyCode() ? UserData.getCompanyCode() : this.user.companyDetail.companyCode);
          formData.append("accessToken", UserData.getAccessToken() ? UserData.getAccessToken() : this.token);
          formData.append("model", "addPublicNotesOnDocument");
          formData.append("companyId", UserData.getCompanyId() ? UserData.getCompanyId() : this.user.companyDetail.companyId);
          formData.append("itemId", this.current_pdf.itemId);
          formData.append("itemParentId", this.current_pdf.itemParentId);
          formData.append("note", this.comment);

          if (this.notes.length > 0)
          {
            formData.append("noteDate", this.notes[0].noteDate);
          }

          this.store.setLoading(true);
          axios.post(UserData.getBaseUrl(), formData).then((response) => {
            this.$emit('add_note', this.comment);
            this.alert.showSuccess(response.data.message);
            this.store.setLoading(false);
            this.reset();
          })
          .catch((e) => {
            console.log("Error", e);
            this.store.setLoading(false);
          });
        }
      });
    },
  },
};
</script>